import { mvc } from '@joint/plus';
export default class IdeaCollection extends mvc.Collection {
}
